export default __webpack_public_path__ + "static/media/account-management.9ed803b5.svg";